import { getToken } from '@hooks/useLocalStorage';
import { MODE } from 'config';

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export let BASE_URL: string;
export let PROD_OR_DEV: string;
export let OTHER_WEB: string[];
export let AWS_URL: string;
export let OTHER_WEB_ADMIN: string[];
export let PRIMARY_COLOR: string;

export const IS_DEV = ENVIRONMENT.includes('dev');

export const PLATFORM = ENVIRONMENT.split(`_`)[0];

export const TEST_BASE_URL = 'http://dev-product-admin.cuma.co.kr';

const jwtToken = getToken();

export const botpressScript = IS_DEV
    ? `https://mediafiles.botpress.cloud/06666fd7-8133-42fe-9e75-216e2d8e21b4/webchat/config.js`
    : `https://mediafiles.botpress.cloud/0a98f0dc-c97b-4031-8fa7-b710df8b270e/webchat/config.js`;

export let CUMA_AI_URL;

switch (ENVIRONMENT) {
    case 'cuma_prod':
        BASE_URL = 'https://service.admin.cuma.co.kr';
        PROD_OR_DEV = 'https://www.cuma.co.kr';
        OTHER_WEB = ['https://www.cumamarket.co.kr', 'https://reucosmetic.com', 'https://jikguair.co.kr'];
        AWS_URL = `https://aws-monitoring.cuma.co.kr/?nodeEnv=${MODE}&token=${jwtToken}`;
        OTHER_WEB_ADMIN = [
            'https://prod.cm-admin.cumamarket.co.kr',
            'https://prod.admin.reucosmetic.com',
            'https://prod.admin.jikguair.co.kr',
        ];
        CUMA_AI_URL = 'https://ai.cuma.co.kr';
        PRIMARY_COLOR = '#FF4D6A';
        break;
    case 'cuma_dev':
        BASE_URL = 'https://dev.service.admin.cuma.co.kr';
        PROD_OR_DEV = 'https://dev-m.cuma.co.kr';
        OTHER_WEB = ['https://dev.cumamarket.co.kr', 'https://dev.reucosmetic.com', 'https://dev.jikguair.co.kr'];
        AWS_URL = `https://aws-monitoring.cuma.co.kr/?nodeEnv=${MODE}&token=${jwtToken}`;
        OTHER_WEB_ADMIN = [
            'https://dev.cm-admin.cumamarket.co.kr',
            'https://dev.admin.reucosmetic.com',
            'https://dev.admin.jikguair.co.kr',
        ];
        CUMA_AI_URL = 'https://ai-dev.cuma.co.kr';
        PRIMARY_COLOR = '#FF4D6A';
        break;
    case 'market_prod':
        BASE_URL = 'https://prod.service.admin.cumamarket.co.kr';
        PROD_OR_DEV = 'https://www.cumamarket.co.kr';
        OTHER_WEB = ['https://www.cuma.co.kr', 'https://reucosmetic.com', 'https://jikguair.co.kr'];
        OTHER_WEB_ADMIN = [
            'https://react.admin.cuma.co.kr',
            'https://prod.admin.reucosmetic.com',
            'https://prod.admin.jikguair.co.kr',
        ];
        CUMA_AI_URL = 'https://ai.cuma.co.kr';
        PRIMARY_COLOR = '#9228d3';
        break;
    case 'market_dev':
        BASE_URL = 'https://dev.service.admin.cumamarket.co.kr';
        PROD_OR_DEV = 'https://dev.cumamarket.co.kr';
        OTHER_WEB = ['https://dev-m.cuma.co.kr', 'https://dev.reucosmetic.com', 'https://dev.jikguair.co.kr'];
        OTHER_WEB_ADMIN = [
            'https://dev-react.admin.cuma.co.kr',
            'https://dev.admin.reucosmetic.com',
            'https://dev.admin.jikguair.co.kr',
        ];
        CUMA_AI_URL = 'https://ai-dev.cuma.co.kr';
        PRIMARY_COLOR = '#9228d3';
        break;
    case 'ru_dev':
        BASE_URL = 'https://dev.service.admin.reucosmetic.com';
        PROD_OR_DEV = 'https://dev.reucosmetic.com';
        OTHER_WEB = ['https://dev-m.cuma.co.kr', 'https://dev.cumamarket.co.kr', 'https://dev.jikguair.co.kr'];
        OTHER_WEB_ADMIN = [
            'https://dev-react.admin.cuma.co.kr',
            'https://dev.cm-admin.cumamarket.co.kr',
            'https://dev.admin.jikguair.co.kr',
        ];
        CUMA_AI_URL = 'https://ai-dev.cuma.co.kr';
        PRIMARY_COLOR = '#6082D3';
        break;
    case 'ru_prod':
        BASE_URL = 'https://prod.service.admin.reucosmetic.com';
        PROD_OR_DEV = 'https://reucosmetic.com';
        OTHER_WEB = ['https://www.cuma.co.kr', 'https://www.cumamarket.co.kr', 'https://jikguair.co.kr'];
        OTHER_WEB_ADMIN = [
            'https://react.admin.cuma.co.kr',
            'https://prod.cm-admin.cumamarket.co.kr',
            'https://prod.admin.jikguair.co.kr',
        ];
        CUMA_AI_URL = 'https://ai-dev.cuma.co.kr';
        PRIMARY_COLOR = '#6082D3';
        break;
    case 'jikgu_dev':
        BASE_URL = 'https://dev.service.admin.jikguair.co.kr';
        PROD_OR_DEV = 'https://dev.jikguair.co.kr';
        OTHER_WEB = ['https://dev-m.cuma.co.kr', 'https://dev.cumamarket.co.kr', 'https://dev.reucosmetic.com'];
        OTHER_WEB_ADMIN = [
            'https://dev-react.admin.cuma.co.kr',
            'https://dev.cm-admin.cumamarket.co.kr',
            'https://dev.admin.reucosmetic.com',
        ];
        CUMA_AI_URL = 'https://ai-dev.cuma.co.kr';
        PRIMARY_COLOR = '#6082D3';
        break;
    case 'jikgu_prod':
        BASE_URL = 'https://prod.service.admin.jikguair.co.kr';
        PROD_OR_DEV = 'https://jikguair.co.kr';
        OTHER_WEB = ['https://www.cuma.co.kr', 'https://www.cumamarket.co.kr', 'https://reucosmetic.com'];
        OTHER_WEB_ADMIN = [
            'https://react.admin.cuma.co.kr',
            'https://prod.cm-admin.cumamarket.co.kr',
            'https://prod.admin.reucosmetic.com',
        ];
        CUMA_AI_URL = 'https://ai-dev.cuma.co.kr';
        PRIMARY_COLOR = '#6082D3';
        break;
    default:
        throw new Error(`Unknown environment: ${ENVIRONMENT}`);
}
